(() => {
  const configNode = document.getElementById('regional-reviews-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const handled = new WeakSet();
  let modulePromise, opening = false, frame = 0;
  function enhance() {
    frame = 0;
    for (const rating of document.querySelectorAll('#mifo-gen4-root .hero-rating, #mifo-gen4-root .proof-rating')) {
      if (handled.has(rating)) continue;
      handled.add(rating);
      rating.dataset.regionalReviews = '';
      rating.setAttribute('role', 'button'); rating.setAttribute('tabindex', '0'); rating.setAttribute('aria-haspopup', 'dialog');
      if (!rating.textContent.toLowerCase().includes('read reviews')) {
        const label = document.createElement('span'); label.className = 'regional-review-label'; label.textContent = 'Read reviews'; rating.append(label);
      }
    }
    const copy = document.querySelector('#mifo-gen4-root .review-copy');
    if (copy && !copy.querySelector('.reviews-explore-button,[data-regional-reviews]')) {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'regional-read-reviews';
      button.dataset.regionalReviews = ''; button.textContent = 'Read all reviews'; button.setAttribute('aria-haspopup', 'dialog'); copy.append(button);
    }
  }
  async function open(trigger) {
    if (opening) return;
    opening = true; trigger.setAttribute('aria-busy', 'true');
    try {
      modulePromise ||= import(config.moduleUrl);
      const module = await modulePromise;
      module.openReviews({ ...config, onReturn() {
        const destination = document.querySelector('#mifo-gen4-root .hero-add') || trigger;
        destination?.scrollIntoView({ block: 'center' }); destination?.focus({ preventScroll: true });
      } });
    } catch { modulePromise = null; document.getElementById('regional-reviews-status').textContent = 'Reviews could not load. Please try again.'; }
    finally { opening = false; trigger.removeAttribute('aria-busy'); }
  }
  const selector = '[data-regional-reviews],#mifo-gen4-root .reviews-explore-button,#mifo-gen4-root .reviews-rating-link';
  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element && event.target.closest(selector);
    if (!trigger) return; event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);
  document.addEventListener('keydown', event => {
    const trigger = event.target instanceof Element && event.target.closest(selector);
    if (!trigger || trigger.tagName === 'BUTTON' || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);
  enhance();
  new MutationObserver(records => {
    if (!frame && records.some(r => [...r.addedNodes].some(n => n instanceof Element && !n.closest('#mifo-reviews-root')))) frame = requestAnimationFrame(enhance);
  }).observe(document.body, { childList: true, subtree: true });
})();
